import { mapState, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ImageItem',
  components: {
    FileSelectorButton
  },
  props: {
    index: Number
  },
  data () {
    return {
      input: {
        uuid: null,
        imageFile: null,
        isEnabled: false,
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // form
      serviceId: state => state.serviceScreenSettingForm.serviceId,
      serviceContentsId: state => state.serviceScreenSettingForm.targetId,
      contentsScreenId: state => state.serviceScreenSettingForm.targetId,
      values: state => state.serviceScreenSettingForm.values,
    }),

    // list
    buttonEnabledList () {
      return Constants.ScreenSetting.ButtonEnabled
    },

    // validate
    formIsValid () {
      return this.validate('imageFile')
    },

    // jsonb
    getJsonb () {
      return this.input
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'image',
          index: this.index,
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'serviceScreenSettingForm/setValidate'
    }),

    init () {
      let data = $.extend(true, this.input, this.values.screenImageSettings[this.index])
      this.$set(this, 'input', data)

      // // 必須項目なし、もしくはラジオボタンのみの場合
      // this.setValidate({
      //   key: 'image',
      //   index: this.index,
      //   value: true
      // })
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      this.$set(this.input, props.name, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', this.input[props.name])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      this.$set(this.input, props.name, null)
      console.log('deleteFileFromSelector', null)
    },

    validate (key) {
      switch (key) {
        case 'imageFile':
          return Validator.validFile(this.input[key])
      }
    },
  }
}
